<svg
viewbox="0 0 448 512"
fill="currentColor"
xmlns="http://www.w3.org/2000/svg">
<path
    d="M433.941 65.941L382.059 14.059C373.057 5.05724 360.848 6.65676e-05
    348.118 0L176 0C149.49 0 128 21.49 128 48V96H48C21.49 96 0 117.49 0
    144V464C0 490.51 21.49 512 48 512H272C298.51 512 320 490.51 320
    464V416H400C426.51 416 448 394.51 448 368V99.882C448 87.1516 442.943
    74.9427 433.941 65.941ZM266 464H54C52.4087 464 50.8826 463.368 49.7574
    462.243C48.6321 461.117 48 459.591 48 458V150C48 148.409 48.6321
    146.883 49.7574 145.757C50.8826 144.632 52.4087 144 54 144H128V368C128
    394.51 149.49 416 176 416H272V458C272 459.591 271.368 461.117 270.243
    462.243C269.117 463.368 267.591 464 266 464ZM394 368H182C180.409 368
    178.883 367.368 177.757 366.243C176.632 365.117 176 363.591 176
    362V54C176 52.4087 176.632 50.8826 177.757 49.7574C178.883 48.6321
    180.409 48 182 48H288V136C288 149.255 298.745 160 312 160H400V362C400
    363.591 399.368 365.117 398.243 366.243C397.117 367.368 395.591 368
    394 368V368ZM400 112H336V48H345.632C347.223 48 348.749 48.632 349.875
    49.757L398.243 98.125C398.8 98.6822 399.242 99.3437 399.544
    100.072C399.845 100.8 400 101.58 400 102.368V112Z" />
</svg>